export const CloseButton = {}

export default CloseButton
